import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const AnalyticsFeedBack = props => {
  const { selectedRow, onClose } = props;

  return (
    <Dialog
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-dialog download-recording-popup"
      onClose={onClose}
    >
      <DialogTitle className="text-center">
        Feedback <br />
        <small>{selectedRow?.profile?.email}</small>
      </DialogTitle>

      <DialogContent>
        <DialogContentText className="text-secondary">
          {selectedRow?.analytics?.feedback}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="custom-dialog-action text-center">
        <Button
          variant="outlined"
          color="secondary"
          onClick={onClose}
          className="events6ix-btn events6ix-btn-light"
          type="button"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AnalyticsFeedBack;
